

//______VARIABLES______//

const
button = document.querySelectorAll(".switch button"),
membre = document.getElementById("membre"),
non_membre = document.getElementById("non-membre"),
section_membre = document.getElementById("section-membre"),
section_non_membre = document.getElementById("section-non-membre")
top_section_img = document.querySelector(".top-section img"),
top_section_texte = document.querySelector(".top-section .text");


let state = true;

const top_section_img_appear = ()=>{
    top_section_texte.style.opacity = 1;
    top_section_texte.style.transform = "translateX(0)";
    top_section_img.style.opacity = 1;
    top_section_img.style.transform = "translateX(0) scale(1)";
};

button.forEach(e=>e.addEventListener("click",()=>{
    membre.classList.toggle("actif");
    non_membre.classList.toggle("actif");
    section_membre.classList.toggle("actif");
    section_non_membre.classList.toggle("actif");
    state = !state;
}))

window.innerWidth>900 && top_section_img_appear()

